<template>
    <div>
        <router-view></router-view>
        <alarm-flash-overlay v-if="hasAlarmsFeature"></alarm-flash-overlay>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AlarmFlashOverlay from '@/components/Alarm/AlarmFlashOverlay'
import { applyBrand, currentBrandName, BRAND_AEI, BRAND_INOBRAM } from '@/utils/brand'

export default {
  name: 'App',
  components: {
    'alarm-flash-overlay': AlarmFlashOverlay
  },
  computed: {
    ...mapGetters({
      hasAlarmsFeature: 'hasAlarmsFeature',
      isAeiOnlyUser: 'isAeiOnlyUser',
      aeiHousesLoaded: 'aeiHousesLoaded',
      deviceFeaturesLoaded: 'deviceFeaturesLoaded'
    }),
    // Null while the answer is not known yet: both lists have to arrive before
    // a customer counts as AEI-only, and reskinning on a half-loaded state
    // would flash Inobram at an AEI customer on every sign-in.
    resolvedBrand () {
      if (!this.aeiHousesLoaded || !this.deviceFeaturesLoaded) return null
      return this.isAeiOnlyUser ? BRAND_AEI : BRAND_INOBRAM
    }
  },
  watch: {
    resolvedBrand (name) {
      if (name) applyBrand(this.$vuetify, name)
    }
  },
  created () {
    // The remembered brand, so a returning customer's login screen is theirs.
    applyBrand(this.$vuetify, currentBrandName())
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue